import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from "../../components/Loader/Loader";
import Avatar from "../../components/Avatar/Avatar";
import DropZone from "../../components/Dashboard/DropZone";

import { doRemoveProfilePicture } from "../../actions/manageUserProfilePicture";
import messages from "../../locale/messages";
import s from './profileUpload.css';

class ProfileUpload extends React.Component {

    render() {
        const { picture, userId, profilePhotoLoader, data, maxUploadSize, doRemoveProfilePicture, isAdmin } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <>
                <div className="editProfileBox">
                    <Loader
                        show={profilePhotoLoader}
                        type={"page"}
                    >
                        <div className="editProfileAvatarContainer">
                            <Avatar
                                source={picture}
                                userId={userId}
                            />
                        </div>

                    </Loader>
                    <div className={!picture && 'marginBottom20'}>
                        <DropZone
                            data={data}
                            maxUploadSize={maxUploadSize}
                            defaultMessage={!picture ? formatMessage(messages.editProfilePhoto) : <></>}
                            isEditIcon={picture ? true : false}
                            isAdmin={isAdmin}
                        />
                    </div>
                </div>
                {
                    picture &&
                    <div className={s.adminProfileRemoveBtnContainer}>
                        <a onClick={() => doRemoveProfilePicture(picture, userId, isAdmin)} className={s.adminProfileRemoveBtn}>
                            <FormattedMessage {...messages.removePhotos} />
                        </a>
                    </div>
                }
            </>
        )
    }
}

const mapState = (state) => ({
    profilePhotoLoader: state?.loader?.profilePhotoLoader
})
const mapDispatch = {
    doRemoveProfilePicture
}

export default compose(injectIntl, withStyles(s), connect(mapState, mapDispatch))(ProfileUpload);